<template>
  <!-- 公示公告 -->
  <div class="page">
    <div class="pageIn">
      <div class="announcement">
        <div class="flex top">
          <div class="flex tabs">
            <div class="tab1" :class="tabsActive==1?'active':''" @click="tabsActive=1;paramQuery=null;tabData()" style="cursor: pointer;">培训公示</div>
            <div class="tab2" :class="tabsActive==2?'active':''" @click="tabsActive=2;paramQuery=null;tabData()" style="cursor: pointer;">信用报告公示</div>
            <div class="tab2" :class="tabsActive==3?'active':''" @click="tabsActive=3;paramQuery=null;tabData()" style="cursor: pointer;">历史公示名单</div>
          </div>

          <div class="flex seach">
            <div class="flex inputBox" style="align-items: center;">
              <div class="seachIcon">
                <img src="/static/images/new/search.png" />
              </div>
              <input v-model="paramQuery"  placeholder="请输入想查找的企业名称" />
			  <img v-show="paramQuery" @click="paramQuery = null,tabData()" style="width: 18px;height: 18px;display: block;margin-right: 10px;" src="/static/images/new/del.png" alt="">
            </div>

            <div class="but" @click="tabData" style="cursor: pointer;">搜索</div>
          </div>
        </div>

        <div class="tables">
          <!--培训公示  -->
          <div class="table1" v-show="tabsActive==1">
            <el-table :data="tableData1" stripe style="width: 100%">
              <el-table-column align="center" type="index" width="80" label="序号">
              </el-table-column>
              <el-table-column align="center" prop="qyMc" label="企业名称">
              </el-table-column>
              <el-table-column align="center" prop="cxsj" label="参训时间">
              </el-table-column>
              <el-table-column align="center" prop="pxcj" label="培训成绩">
              </el-table-column>
              <el-table-column align="center" prop="qySa01" label="证书编号">
              </el-table-column>
              <el-table-column align="center" prop="fwjg" label="服务机构">
              </el-table-column>
            </el-table>
            <!-- 页码  page1-->
            <div class="pageSize">
              <div class="paginationBox">
                <el-pagination @size-change="handleSizeChange" background @current-change="handleCurrentChange"
                  :current-page="page1" :page-sizes="[5, 10, 20]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper"
                  :total="totalA">
                </el-pagination>
              </div>
            </div>
          </div>
          <!-- 信用报告公示 -->
          <div class="table2" v-show="tabsActive==2">
            <el-table :data="tableData2" stripe style="width: 100%">
              <el-table-column align="center" width="80" type="index" label="序号">
              </el-table-column>
              <el-table-column align="center" prop="qyMc" label="企业名称">
              </el-table-column>
              <el-table-column align="center" prop="bgrq" label="报告时间">
              </el-table-column>
              <!-- <el-table-column align="center" prop="kscj" label="培训成绩">
              </el-table-column> -->
              <el-table-column align="center" prop="qySa01" label="报告编号">
              </el-table-column>
              <el-table-column align="center" prop="fwjg" label="服务机构">
              </el-table-column>
            </el-table>
            <!-- 页码  page2-->
            <div class="pageSize">
              <div class="paginationBox">
                <el-pagination @size-change="handleSizeChange" background @current-change="handleCurrentChange"
                  :current-page="page2" :page-sizes="[5, 10, 20]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper"
                  :total="totalB">
                </el-pagination>
              </div>
            </div>
          </div>
          <!-- 历史公示名单 -->
          <div class="table3" v-show="tabsActive==3">
            <el-table :data="tableData3" stripe style="width: 100%">
              <el-table-column align="center" type="index" width="80" label="序号"></el-table-column>
              <el-table-column align="center" prop="qyMc" label="企业名称"></el-table-column>
              <el-table-column align="center" prop="cxsj" label="参训时间"></el-table-column>
              <el-table-column align="center" prop="pxcj" label="培训成绩"></el-table-column>
              <el-table-column align="center" prop="qySa01" label="证书编号"></el-table-column>
              <el-table-column align="center" prop="fwjg" label="服务机构"></el-table-column>
            </el-table>
            <!-- 页码  page3-->
            <div class="pageSize">
              <div class="paginationBox">
                <el-pagination @size-change="handleSizeChange" background @current-change="handleCurrentChange"
                  :current-page="page3" :page-sizes="[5, 10, 20]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper"
                  :total="totalC">
                </el-pagination>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        page1: 1,
        page2: 1,
        page3: 1,
        pageSize: 10,
        // pageSize2: 10,
        totalA: null,
        totalB: null,
        totalC: null,
        paramQuery: null, //搜索值
        tabsActive: 1, //tab 切换
        tableData1: [],
        tableData2: [],
        tableData3: [],
      }
    },
    created() {
      this.getPxgs();
      this.getXybggs();
      this.getHistorys();
    },
    methods: {
      handleSizeChange(val) {
        console.log(`每页 ${val} 条`);
        this.pageSize = val;
        this.tabData();
      },
      handleCurrentChange(val) {
        console.log(`当前页: ${val}`);
        if (this.tabsActive == 1) {
          this.page1 = val;
        } else if (this.tabsActive == 2) {
          this.page2 = val;
        } else {
          this.page3 = val;
        }
        this.tabData();
      },
      tabData() {
        if (this.tabsActive == 1) {
          this.getPxgs();
        } else if (this.tabsActive == 2) {
          this.getXybggs();
        } else {
          this.getHistorys();
        }
      },
      //培训公示
      getPxgs() {
        const loading = this.$loading({
          lock: false,
          text: "Loading",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)",
        });
        let ajax = this.$http.create();
        ajax.post(SOWINURL + 'report/makeList', {
          paramQuery: this.paramQuery,
          pageLimit: this.pageSize,
          currPage: this.page1
        }).then(res => {
          if (res.data.result == 1) {
            this.totalA = res.data.data.allNum;
            this.tableData1 = res.data.data.list;
            loading.close();
          } else {
            loading.close();
            this.$message.error('查询出错!');
          }
        }).catch(err => {
          loading.close();
          this.$message.error('查询出错!');
        })
      },
      //信用报告公示
      getXybggs() {
        let ajax = this.$http.create();
        ajax.post(SOWINURL + 'report/makeReportList', {
          paramQuery: this.paramQuery,
          pageLimit: this.pageSize,
          currPage: this.page2
        }).then(res => {
          if (res.data.result == 1) {
            this.tableData2 = res.data.data.list;
            this.totalB = res.data.data.allNum;
          } else {
            this.$message.error('查询出错!');
          }
        }).catch(err => {
          this.$message.error('查询出错!');
        })
      },
      //历史公示名单
      getHistorys() {
        let ajax = this.$http.create();
        ajax.post('https://xyxf-api.linksgood.com/report/makeList', {
          qyMc: this.paramQuery,
          pageLimit: this.pageSize,
          currPage: this.page3
        }).then(res => {
          if (res.data.result == 1) {
            this.tableData3 = res.data.data.list;
            this.totalC = res.data.data.allNum;
          } else {
            this.$message.error('查询出错!');
          }
        }).catch(err => {
          this.$message.error('查询出错!');
        })
      }
    }
  }
</script>

<style scoped lang="less">
  .flex {
    display: flex;
  }

  .page {
    background-color: #F7F7F7;
  }

  .pageIn {
    width: 1180px;
    margin: 0 auto;
    min-height: 369px;
    padding: 20px 0;
    box-sizing: border-box;
  }

  .announcement {


    .top {
      margin-bottom: 20px;
      justify-content: space-between;
      background-color: #FFFFFF;
      align-items: center;

      .seach {
        align-items: center;
        background-color: #F4F4F4;
        padding: 6px 0 6px 10px;
        height: 36px;
        box-sizing: border-box;
        border-radius: 4px;
        margin-right: 24px;

        .inputBox {
          background-color: #F4F4F4;
          height: 100%;
        }

        .seachIcon {
          width: 24px;
          height: 24px;

          img {
            width: 100%;
            height: 100%;
          }
        }

        input {
          margin: 0;
          padding: 0;
          border: 0;
          height: 100%;
          padding-left: 3px;
          background-color: initial;
        }

        input:focus {
          outline: none;
          border: 0;
        }

        .but {
          background-color: #4698FF;
          width: 54px;
          text-align: center;
          height: 36px;
          border-radius: 0px 4px 4px 0px;
          font-size: 14px;
          font-weight: 500;
          color: #FFFFFF;
          line-height: 36px;
        }
      }

      .active {
        background-color: #EEF0F3;
        color: #0091FF;
      }

      .tabs {
        background-color: #FFFFFF;
        height: 54px;
        line-height: 54px;
        font-size: 16px;
        font-weight: bold;
        color: #4E4E4E;
      }

      .tabs>div {
        width: 127px;
        text-align: center;
        height: 100%;
      }
    }

    .tables {

      .pageSize {
        margin-top: 24px;
        display: flex;
        justify-content: center;
      }

      .paginationBox {}
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/index/announcement.vue